// @ts-nocheck
import React from 'react';

const AdsLogo = () => {
  return (
    <>
      <svg
        width="29"
        height="26"
        viewBox="0 0 29 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6951 7.40506C19.3016 6.36182 19.4637 5.11869 19.145 3.95479C18.8263 2.79089 18.0535 1.80376 17.0001 1.21506C14.8131 -0.0228918 12.0378 0.712009 10.7501 2.87006C10.6951 2.97006 10.6401 3.07006 10.5951 3.17006L6.3101 10.5001C6.21569 10.6455 6.1289 10.7957 6.0501 10.9501L1.6001 18.6201L9.5451 23.0701L13.9701 15.4651C14.068 15.3209 14.1565 15.1706 14.2351 15.0151L18.5001 7.68506C18.5647 7.59479 18.6248 7.50134 18.6801 7.40506"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5852 23.0498C8.32695 25.2618 5.51687 26.0398 3.3002 24.7898C1.09972 23.5348 0.330091 20.7355 1.57963 18.5319C2.82917 16.3283 5.62646 15.5516 7.83322 16.7956C10.04 18.0396 10.8237 20.835 9.5852 23.0448"
          fill="#34A853"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.7301 8.8549C24.5645 7.60298 21.7943 8.33857 20.5351 10.4999L16.0001 18.3499C15.3947 19.3863 15.2284 20.6216 15.5383 21.7812C15.8481 22.9408 16.6084 23.9286 17.6501 24.5249C19.8182 25.7751 22.5893 25.0348 23.8451 22.8699L28.3801 15.0299C28.9854 13.9935 29.1517 12.7582 28.8418 11.5986C28.532 10.439 27.7717 9.45122 26.7301 8.8549Z"
          fill="#4285F4"
        />
      </svg>
    </>
  );
};
export default AdsLogo;
